import React from 'react';
import { Label } from 'reactstrap';
import { ValidatedField, Storage, translate } from 'react-jhipster';

export const IbanForm = ({ ibanEntity }) => {
  return (
    <>
      {/* IBAN */}
      <div className="form-group row" style={{ alignItems: 'center' }}>
        <div className="col-sm-3">
          <Label>{translate('comexApp.quotation.ibanNumber')}</Label>
        </div>
        <div className="col-sm-9">
          <ValidatedField
            id="iban"
            name="iban"
            type="text"
            style={{
              textAlign: Storage.session.get('locale') === 'en' ? 'left' : 'right',
            }}
            value={ibanEntity?.ibanNumber}
            disabled={true}
          />
        </div>
      </div>

      {/* BANK NAME */}
      <div className="form-group row" style={{ alignItems: 'center' }}>
        <div className="col-sm-3">
          <Label>{translate('comexApp.quotation.bankName')}</Label>
        </div>
        <div className="col-sm-9">
          <ValidatedField id="bankName" name="bankName" type="text" value={ibanEntity?.ibanBankName} disabled={true} />
        </div>
      </div>

      {/* BRANCH NAME */}
      <div className="form-group row" style={{ alignItems: 'center' }}>
        <div className="col-sm-3">
          <Label>{translate('comexApp.quotation.branchName')}</Label>
        </div>
        <div className="col-sm-9">
          <ValidatedField id="branchName" name="branchName" type="text" value={ibanEntity?.ibanBranchName} disabled={true} />
        </div>
      </div>
    </>
  );
};
